//opt import sha256 from "crypto-js/sha256";
import React, {  useState } from "react";
//opt import { Main , Hashs } from "./styles/Main";

import styled from "styled-components";
import AnimECC  from "../bilder/animation-tangent-line.gif";
import { Breakpoint  } from 'react-socks';

 function quersumme(forceOneDigit) {
    var z = forceOneDigit.toString().split('');
    for (var i=0, quer=0; i < z.length; quer+=z[i++]-0);

    return quer;
}

 
 function multkeyx(p,pointarray) {
	//var x=0;
	p=parseInt(p+"")%7;
	if (parseInt(p+"")%7 < 1) return 0;
	 return Math.floor(pointarray[(parseInt(p+"")%7-1)]/10); //p=1,2,..6
	//return x
 }
 function multkeyy(p,pointarray) {
	// var y=0;
	//p=parseInt(p+"")%7;
	if (parseInt(p+"")%7 < 1) return 0;	 
	return pointarray[(parseInt(p+"")%7-1)]%10;
	//return y
 }
 function calczhash(msg) {
	 return quersumme(msg)%7
 }
 
 function calcsigs(k,z,r,priv) {
//	var v= cinv7(k);
//	var w=(z+r*priv);
	 if (k===0 || cinv7(k)===0||r===0||priv ===0 || z+r*priv ===0) {
		 return 0;
	 }
	return cinv7(k)*(z+r*priv)%7 //               (v*w)%7
 }
 
function cinv7(cs) {
	 var cinv=[1,4,5,2,3,6];
	 cs=parseInt(cs+"")%7;
	 if (cs < 1) return 0;
	 return cinv[cs-1];
 } 
 function kinv7(ks) {
	 var kinv=[1,4,5,2,3,6];
	 ks=parseInt(ks+"")%7;
	 if (ks < 1) return 0;
	 return kinv[ks-1];
 }
 


export default function ECDSAComponent() {
	
  const fzupx = function(){
	  return parseInt(values.zuf)>0? multkeyx(values.zuf,pointArray)%7:0;
  }
  const fzupy = function(){
	  return parseInt(values.zuf)>0?multkeyy(values.zuf,pointArray)%7:0;
  }
  const fzhash = function(){
	  return calczhash(values.mess);
  }  
  const fpubdx = function(){
	  return multkeyx(values.privkey,pointArray);
  }    
  const fpubdy = function(){
	  return multkeyy(values.privkey,pointArray);
  }   
 
 const fsigr = function(){
	  return ((values.zuf)>0)?multkeyx(values.zuf,pointArray):""  ;
  } 

  const fsigs = function(){
	  return ((values.zuf * values.privkey * fzhash()%7)>0)?
	  calcsigs(values.zuf,fzhash(),fzupx(),values.privkey):"";
  }   
 
  const fzfinv = function(){
	  return (((values.zuf)>0))?kinv7(values.zuf):"";
  }  
  const fsinv = function(){
	  return ((values.zuf * values.privkey * calczhash(values.mess)%7)>0)? 
				cinv7(calcsigs(values.zuf,	fzhash(),fzupx(),values.privkey)):"";
  }  


					
    const state={
	lnk: [ 
		   {id:1, imgUrl: AnimECC, stl:{float:"left",width:"25%"},w:"50%",h:"50%",mw:"100vh",mh:"100vh", 
			lnkUrl: "https://bc.linslernet.de/ecc/modk-mul.htm",title: "Eliptische Kurven"},
	],
  };
  
 
  const pointArray=[
	11,21,46,41,26,16,
	21,41,16,11,46,26,
	46,16,21,26,11,41,
	41,11,26,21,16,46,
	26,46,11,16,41,21,
	16,26,41,46,21,11];

//aG + bG = pointAddArray[(a-1)+6(b-1)] a=1,2,6 b=
//        = (a+b)G
// const pointAddArray=[
//	1G 2G 3G 4G 5G 6G
//  11,21,46,41,26,16,  
// 11	21,46,41,26,16, 0,  //a=1, b=1,2,... 6
// 21	46,41,26,16, 0,11,	//a=2, b=1,2,... 6
// 46	41,26,16, 0,11,21,
// 41	26,16, 0,11,21,46,
// 26	16, 0,11,21,46,41,
// 16	 0,11,21,46,41,26];	//a=6, b=1,2,.....6
//b =1 =2 =3 ......=6 a=1,2,...6
      
 
 
  const [values, setValues] = useState({
	privkey: "",
	pubkx: "",
	pubky: " ",
	zuf: "",
	zufpx: "",
	zufpy: " ",	
	sigs: " ",
	sigr: " ",
	mess: " ",
	zhash: " ",
	zhashcl: " ",
	zfinv: " ",
	sinf: " ",
    prfnr:"",
    sig:"",
	verf:"",
	u1: " ",
	u1x:"",
	u1y:"",
	u2: " ",
	u2x:"",
	u2y:"",
	xp: "",
	yp: "",
  });



const valuesReset = ()=>{
	setValues(
	{
	privkey: "",
	pubkx: "",
	pubky: " ",
	zuf: "",
	zufpx: "",
	zufpy: " ",	
	sigs: " ",
	sigr: " ",
	mess: " ",
	zhash: " ",
	zhashcl: " ",
	zfinv: " ",
	sinf: " ",
    prfnr:"",
    sig:"",
	verf:"",
	u1: " ",
	u1x:"",
	u1y:"",
	u2: " ",
	u2x:"",
	u2y:"",
	xp: "",
	yp: "",
  });
}

  const set = (name) => {
//console.log(values);
//setValues (fieldsDelta:FieldsDelta) =>
//	void FieldDelta = { [fieldPath: string]: any | FieldsDelta		
    return ({ target: { value } }) => {
      setValues((oldValues) => ({
        ...oldValues,
        [name]: value,
	
//		["zfinv"]:	(((oldValues.zuf)>0))?kinv7(oldValues.zuf):"",
//		["sigr"] :	(((oldValues.zuf)>0))?multkeyx(oldValues.zuf,pointArray):"",
//		["sigs"]:	((oldValues.zuf * oldValues.privkey * calczhash(oldValues.mess)%7)>0)? 
//			calcsigs(oldValues.zuf,calczhash(oldValues.mess),multkeyx(oldValues.zuf,pointArray),oldValues.privkey):"",
//		["sinv"] :	((oldValues.zuf * oldValues.privkey * calczhash(oldValues.mess)%7)>0)? 
//			cinv7(calcsigs(oldValues.zuf,calczhash(oldValues.mess),multkeyx(oldValues.zuf,pointArray),oldValues.privkey)):"",

//		["u1"]   : 	(oldValues.zhash)%7 *(((oldValues.zuf * oldValues.privkey * calczhash(oldValues.mess)%7)>0)? 
//						cinv7(calcsigs(oldValues.zuf,calczhash(oldValues.mess),multkeyx(oldValues.zuf,pointArray),oldValues.privkey)):""),
//		["u1x"]  :	multkeyx((oldValues.zhash)%7 *(((oldValues.zuf * oldValues.privkey * calczhash(oldValues.mess)%7)>0)? 
//						cinv7(calcsigs(oldValues.zuf,calczhash(oldValues.mess),multkeyx(oldValues.zuf,pointArray),oldValues.privkey)):"") ),
//		["u1y"]  :	multkeyy((oldValues.zhash)%7 *(((oldValues.zuf * oldValues.privkey * calczhash(oldValues.mess)%7)>0)? 
//						cinv7(calcsigs(oldValues.zuf,calczhash(oldValues.mess),multkeyx(oldValues.zuf,pointArray),oldValues.privkey)):"") ),
//		["u2"]   : 	(((oldValues.zuf * oldValues.privkey * calczhash(oldValues.mess)%7)>0)? 
//			cinv7(calcsigs(oldValues.zuf,calczhash(oldValues.mess),multkeyx(oldValues.zuf,pointArray),oldValues.privkey)):""
//						* (((oldValues.zuf)>0))?multkeyx(oldValues.zuf,pointArray):"")%7,
//		["u2x"]  :	multkeyx(
//						(oldValues.u2 * 
//						oldValues.privkey)%7,pointArray),
//		["u2y"]  :	multkeyy((oldValues.u2*oldValues.privkey)%7,pointArray),
//		["xp"]	:	RxPxPyQxQy(
//					multkeyx((sinv7(oldValues.sigs) * oldValues.zhash)%7,pointArray),
//					multkeyy((sinv7(oldValues.sigs) * oldValues.zhash)%7,pointArray),
//					multkeyx((sinv7(oldValues.sigs) * oldValues.sigr * oldValues.privkey)%7,pointArray),
//					multkeyy((sinv7(oldValues.sigs) * oldValues.sigr * oldValues.privkey)%7,pointArray),pointArray),
//		["yp"]	:	RyPxPyQxQy(
//					multkeyx((sinv7(oldValues.sigs) * oldValues.zhash)%7,pointArray),
//					multkeyy((sinv7(oldValues.sigs) * oldValues.zhash)%7,pointArray),
//					multkeyx((sinv7(oldValues.sigs) * oldValues.sigr * oldValues.privkey)%7,pointArray),
//					multkeyy((sinv7(oldValues.sigs) * oldValues.sigr * oldValues.privkey)%7,pointArray),pointArray),
//		["zhash"]:	calczhash(oldValues.mess),
		
      }));
    };
  };

  return (
    <>
	<h1>ECDSA</h1>

	Bei der Signatur von Bitcoin und Co. Transaktionen ergeben sich Hash-Zahlen zwischen <b>0</b> und <br/> <b> 115.792. 089.237.316. 195.423.570. 985.008.687. 907.853.269. 984.665.640. 564.039.457. 584.007.908. 834.671.663. </b>Das sind 
	78 Dezimalstellen! (Binär 256 Bit) und das Hash <b>sha256</b> ändert seinen Wert unvorhersehbar bei kleinsten Änderungen in der Nachricht!
<br/>

	<ol>Bitcoin und Co. verwenden zur Berechnung der Signatur das Verfahren <b>"ECDSA"</b> (Elliptic Curve Digital Signature Algorithm), ein mathematisch anspruchvolles Verfahren.
	</ol>
	  Eine Teilmenge von Punkten (x,y) aus der Menge &#8477;X&#8477;, welche die Gleichung 
	  <ol>y<sup>2</sup>=x<sup>3</sup> + ax + b erfüllen (mit a,b aus &#8477; und 4a<sup>3</sup>+27b<sup>2</sup>&ne;0) ist eine eliptische Kurve über &#8477;.</ol>
	  Bei den elliptischen Kurven <b>schneidet</b> die Verbindungs-Gerade <b>zweier</b> unterschiedlicher Punkte die Kurve (siehe Abbildung unten, gelbe Gerade und gelbe Punkte) <b>genau </b>noch 
	  <b> einmal</b> und man definiert den roten Punkt mit dem an der x-Achse gespiegelten y-Wert als die Summe der beiden Punkte.<br/><br/> Bei der Addition
	  eines Punktes mit sich selbst nimmt man die Tangente an die Kurve als Gerade und falls die Gerade parallel zur y-Achse verläuft definiert man 
	  unendlich als "Summe". <br/>(Bei der Verschlüsselung bzw.Signatur auf Basis elliptischer Kurven werden nur ganzzahlige Kurvenpunkte (n,m) 
	  Modulo einer vorgegebenen Primzahl betrachtet. Beispiel siehe unten)<br/> <br/>
	  
	  Mit einer geheimen natürlichen Zahl <b>n als privatem Schlüssel</b> und einem öffentlich bekannten "Basispunkt" P auf der Kurve wird die n-fache Addition von P: <b>(n*P)=(s,t)</b> zum
	  zugehörigen <b>öffentlichen Schlüssel.</b> Der <b>ECDSA </b> - "Elliptic Curve Digital Signature Algorithm" ist der bei den Crypto-Coins meist 
	  verwendete Signaturalgorithmus.<br/> <br/>
	  (<a href="https://andrea.corbellini.name/2015/05/17/elliptic-curve-cryptography-a-gentle-introduction/"> Andrea Corbellini: Elliptic Curve Cryptography - a gentle introduction.</a>)
	  <br/><br/>
	
	  <a href="ecc/modk-mul.html" target="_blank" rel="noreferrer"><img src={AnimECC}  alt="ECC-Multiplikation" style={state.lnk[0].stl}></img> </a>

	  <i>Das Bild zeigt auf einer <b>"elliptischen Kurve" y<sup>2</sup>=x<sup>3</sup>+ax+b </b>  mit (4a<sup>3</sup>+27b<sup>2</sup> &ne; 0 und  x und y reelle Zahlen) die <b>"Addition" </b> zweier gelb gezeichneter Punkte (x,y) mit dem roten Punkt als Ergebnis.<br/><br/>
	  Bei den elliptischen Kurven <b>schneidet</b> die Verbindungs-Gerade <b>zweier</b> unterschiedlicher Punkte die Kurve <b>genau </b>noch 
	  <b> einmal</b> und man definiert den roten Punkt mit dem an der x-Achse gespiegelten y-Wert als die Summe der beiden Punkte. Bei der Addition
	  eines Punktes mit sich selbst nimmt man die Tangente an die Kurve als Gerade und falls die Gerade parallel zur y-Achse verläuft definiert man 
	  unendlich als "Summe". </i><br/><br/>
	  
	  Hat man zwei verschiedene Punkte 
	<ol><b>P=(x<sub>P</sub>,y<sub>P</sub>)</b> und <b>Q=(x<sub>Q</sub>,y<sub>Q</sub>)</b>, 
	  mit x<sub>P</sub> &ne; x<sub>Q</sub> , 
	</ol>
	dann hat die Gerade die Steigung 
	<ol>
	  <b>m=(y<sub>P</sub>-y<sub>P</sub>)/(x<sub>P</sub>-x<sub>P</sub>)</b>,
	 </ol> 
	  und der 
	  Schnittpunkt mit der elliptischen Kurve ist der Punkt  
	<ol>
	 <b>R=(x<sub>R</sub>,y<sub>R</sub>) </b>
	  mit <b> x<sub>R</sub>=m<sup>2</sup>-x<sub>P</sub>-x<sub>Q</sub> </b>
	  und <b> y<sub>R</sub>=y<sub>Q</sub>+m(x<sub>R</sub>-x<sub>Q</sub>)</b>
	</ol>
	Als Summe von P und Q wird dann -R definiert. <br/><br/>
	  Wenn <b>P=Q</b> ist, dann ist die Steigung der Tangente im Punkt P der Wert der Ableitung
	<ol>  
	  <b>m =(3x<sup>2</sup><sub>P</sub>+a)/2y<sub>P</sub> </b>
	</ol>
	<hr/>
	  Bei der Verschlüsselung bzw. Signatur auf Basis elliptischer Kurven werden nur ganzzahlige Kurvenpunkte (x,y) Modulo 
	  einer vorgegebenen Primzahl P betrachtet.<br/><br/>
	  Bei Bitcoin wird die elliptische Kurve mit a=0 und b=7 mit einer sehr großen Primzahl eingesetzt:
	<ol>
		<b>P = 115.792. 089.237. 316.195. 423.570. 985.008. 687.907. 853.269. 984.665. 640.564. 039.457. 584.007. 908.834. 671.663</b> (78 Dezimalstellen) oder<br/> 
		<b>P = 0xffffffff. ffffffff. ffffffff. ffffffff. ffffffff. ffffffff. fffffffe. fffffc2f</b> hexadezimal oder berechnet<br/>
		<b>P = 2<sup>256</sup> - 2<sup>32</sup> - 2<sup>9</sup> - 2<sup>8</sup> - 2<sup>7</sup> - 2<sup>6</sup> 2<sup>4</sup> - 1.</b> und damit 256 bit groß.<br/>

	</ol>
	  Zur Demonstration wählen wir diese Kurve mit einer sehr kleinen Primzahl <b>P=7</b>
	<ol>
	 <b>y<sup>2</sup> <small><sub>|mod7</sub></small> = (x<sup>3</sup>+7) <small><sub>|mod7</sub></small></b> <br/>(mit der Primzahl 7 und x,y=0,1,..,7)  
	</ol> Andrea Corbellini hat in seinen Beiträgen "Elliptic Curve Cryptography - a gentle-introduction "  
	 <a href="https://andrea.corbellini.name/2015/05/17/elliptic-curve-cryptography-a-gentle-introduction/"  rel="noreferrer">(Link</a>) auch ein Programm zur Anzeige 
	 der Punkte dieser Funktionen unter <a href="http://opensource.org/licenses/MIT"  target="_blank"  rel="noreferrer">MIT-Lizenz</a>  veröffentlicht, deren übersetzte Version sie 
	 <a href="https://bc.linslernet.de/ecc/modk-mul.html"  target="_blank" rel="noreferrer" > hier</a> ausprobieren können.<br/><br/>
	 Starten wir mit dem Punkt P=(1,1) und berechnen den Schnittpunkt der
	"Tangenten-Gerade" von P im Punkt (1,1) mit der Kurve durch einsetzen mit den oben aufgeführten Formeln, dann gilt 
	(wir rechnen Modulo 7, mit ganzen Zahlen):<br/>
	 m bei Tangente (P=Q)
<ol> 
	<b>m</b><small><sub>|mod7</sub></small><b>=(3*x<sub>P</sub><sup>2</sup>)*(2*y<sub>P</sub>)<sup>-1</sup></b><small><sub>|mod7</sub></small>
	<b>= </b> <br/><i>(falls P &ne; Q   m=(y<sub>P</sub>-y<sub>P</sub>)*(x<sub>P</sub>-x<sub>P</sub>)<sup>-1</sup>)</i>
</ol>
 <b>P=(1,1)=Q</b>
<ol>	
	<b>m</b><small><sub>|mod7</sub></small><b>=(3*1<sup>2</sup>)*(2*1)<sup>-1</sup></b><small><sub>|mod7</sub></small>
	<b>= 3*4</b><small><sub>|mod7</sub></small><b> = 5</b> <br/>
</ol>da a=0 und das Inverse von 2<small><sub>|mod7</sub></small> ist 4 ( 2*4<small><sub>|mod7</sub></small>=1)<br/>
<ol> <b>x<sub>R</sub>=(5)<sup>2</sup>-1-1 <small><sub>|mod7</sub></small> = 23<small><sub>|mod7</sub></small> = 2 </b>
</ol>
<ol>
	<b>y<sub>R</sub>=y<sub>P</sub>+m(x<sub>R</sub>-x<sub>P</sub>)<small><sub>|mod7</sub></small>=1+5*(2-1)<small><sub>|mod7</sub></small>=6<small><sub>|mod7</sub></small>   </b>
</ol>	
Der <b>Schnittpunkt</b> der <b>Tangente</b> im Punkt <b>P=(1,1)</b> mit der elliptischen Kurve <b>y<sup>2</sup> modulo 7 = (x<sup>3</sup>+7) modulo 7</b> ist <b>(2,6) </b>
und bei P+P wird der negative y-Wert des Schnittpunktes genommen
<ol>
<b> P+P=2*P=(1,1)+(1,1) = (2,-6)<small><sub>|mod7</sub></small> = (2,-6+7)<small><sub>|mod7</sub></small> =(2,1)<small><sub>|mod7</sub></small> </b>
</ol>	  
	Nehmen wir <b>(1,1)</b> als <b>Basispunkt P</b>, dann ergibt sich mit dem gleichen Rechenverfahren bei der "Addition" von:<br/>
	<b>&nbsp;&nbsp;&nbsp;&nbsp;P+P = (2,1) = 2*P<br/>
	2*P+P = (4,6) = 3*P<br/>
	3*P+P = (4,1) = 4*P<br/>
	4*P+P = (2,6) = 5*P<br/>
	5*P+P = (1,6) = 6*P<br/></b>
	
<br/>
	  Mit einer geheimen natürlichen Zahl 
	<b> n als privatem Schlüssel</b>
	<br/>
		und einem öffentlich bekannten <b>"Basispunkt" P</b> wird die n-fache Addition von P 
	<br/>	 <b> (n*P)=(s,t) </b> 
	  zum dazugehörigen <b>öffentlichen Schlüssel.</b>
	<br/><br/>
	<u>Beispiele</u> mit a=0, b=7, mod7:<br/> <b>privKey=3, pubKey = (4,6)</b> oder  <b>privKey=6, pubKey = (1,6)</b><br/><br/> 
	
	<hr/>  
	<p> Liegt eine beliebige Nachricht in elektronischer Form vor (eine Text, eine Transaktion, usw) und möchte der Ersteller, die Erstellerin
	bestätigen, dass sie von ihm oder ihr stammt, dann wird zunächst 
	<ul>
	<li>mit einer bekannten Rechenvorschrift eine eindeutige Zahl aus der Nachricht	berechnet, die sich <b>Hash</b> der Nachricht nennt.
	</li><br/>
	<li>Mit einer nur dem Aussteller, der Ausstellerin bekannten Zahl, die <b>"Privater Schlüssel" </b> genannt wird und dem Hash der Nachricht, 
	werden je nach Signierverfahren eine Zahl <b>Sig</b>=s (RSA/PGP), oder ein Tupel mit zwei Zahlen <b>Sig</b>=(e,s) (DSA,ECDSA) berechnet und veröffentlicht.
	</li><br/>
	<li> Zu dem privaten Schlüssel gibt es einen passendem <b>" Öffentlichen Schlüssel "</b>, der öffentlich bekannt ist und mit dessen Hilfe man aus der
	bereitgestellten Signatur, der Nachricht prüfen kann, dass die Signatur mit dem passenden geheimen Schlüssel erstellt wurde.
	</li>
	</ul>
	</p>
	Bei unserem EggCoin verwenden wir ein ganz einfaches, an die RSA Signatur angelehntes Verfahren, die Einschränkung des Zahlenbereiches auf ganze 
	Zahlen zwischen 0 und 100 (Modulo 100) und die Signatur - Erstellung durch Potenzierung des Hash's mit dem geheimen Schlüssel sowie die Signatur-Prüfung 
	durch Potenzierung der Signatur mit dem öffentliche Schlüssel. Die Hashfunktion ist dabei die Quersumme aller vorkommenden Ziffern auf die nächste
	ungeragde Zahl ungleich 5 erhöht. (siehe Mod100 oder Hash)<br/><br/>
	Oben haben wir für die elliptische Kurve 
	<b> y<sup>2</sup><small><sub>|mod7</sub></small>=
	(x<sup>3</sup>+7)<small><sub>|mod7</sub></small></b> und den Basispunkt <b>P=(1,1)</b> die Werte für die 2 bis 6-fache Addition 
	<b> P+P=2*P=(2,1) </b> bis <b>6*P=(1,6)</b> aufgeführt (q-fache Addition: Schritt für Schritt mit der Berechnung der Schnittpunkte der Kurve mit der 
	jeweiligen Gerade durch (q-1)*P und P oder per Programm von A.Corbelli) <br/><br/>
	<hr/>
	Hier der <b>Algorithmus</b> zur Erstellung der <b>ECDSA - Signatur </b> auf einer elliptischen Kurve mit Punkten (x,y) ganzer Zahlen Modulo einer 
	Primzahl n und einem Punkt <b>G als Basispunkt</b> (alle Zahlen modulo n): 
	<ol style={{ "list-style": "none","padding-left" : 1 }}>
	<b>d</b> sei der <b>private Schlüssel</b> des Unterzeichners (eine ganze Zahl kleiner n),
	<b>H=d*G</b> der dazugehörige öffentliche Schlüssel und <b>z=Hash(Nachricht)<small><sub>|mod n</sub></small></b>
	
	</ol>
	{//<ol style={{ "list-style": "none","padding-left" : 1 }}>
	}
	<b><u>Signatur Erstellung</u></b>
	<ol style={{"padding-left" : 5 }}>
	<li> Wähle <b>zufällig</b> eine ganze Zahl <b>k</b> größer 1 und kleiner n </li>
	<li> Berechne den Punkt <b>P=k*G=(x<sub>P</sub>,y<sub>P</sub>)</b> </li>
	<li> Berechne die <b>erste Zahl der Signatur r=x<sub>P</sub><small><sub>|mod n</sub></small></b> </li>
	<li> Falls r=0 ist, dann wähle ein anderes k zufällig </li>
	<li> Berechne die <b>2. Zahl der Signatur s</b> mit dem Inversen <b>k<sup>-1</sup> <small><sub>|mod n</sub></small></b> (k*k<sup>-1</sup><small><sub>|mod n</sub></small>=1)<br/>
		<b>s=k<sup>-1</sup>*(z+r*d)</b></li>
	<li> Wenn s=0 ist, dann mit einem anderen k wieder ab Punkt 1.</li>
	</ol>
	Das Zahlenpaar <b>(r,s) ist die Signatur</b> der Nachricht der Unterzeichnerin.<br/><br/>
	<b><u>Signatur Überprüfung</u></b>
	<ol style={{"padding-left" : 5 }}>
	<li> Berechne <b> u<sub>1</sub>=s<sup>-1</sup>z<small><sub>|mod n</sub></small>  </b> mit <b>s*s<sup>-1</sup><small><sub>|mod n</sub></small> =1</b></li>
	<li> Berechne <b> u<sub>2</sub>=s<sup>-1</sup>r<small><sub>|mod n</sub></small>  </b></li>
	<li> Berechne den Punkt <b>P=u<sub>1</sub>G+u<sub>2</sub>H </b></li>
	</ol>
	Die Signatur ist gültig, wenn für die x-Koordinate von P gilt:<br/> <b>x<sub>P</sub>=r <small><sub>|mod n</sub></small> </b>
	<hr/>
	Nachfolgend können Sie mit der Kurve 
	<b> y<sup>2</sup><small><sub>|mod7</sub></small>=
	(x<sup>3</sup>+7)<small><sub>|mod7</sub></small></b>, n=7, dem Basispunkt <b>G=(1,1)</b> und unserer einfachen <b>Prüfziffer als Hash </b>
	 Signaturen berechnen und verifizieren.<br/><br/>
	 			<ol style={{"padding-left" : 5 }}><font size="3">Eingabe privaten Schlüssel <b>d</b>, Zufallszahl <b>k </b>  
			beide aus (1,2,3,4,5,6) und die zu signierende Nachricht <b>msg</b></font>
			</ol>


	<Breakpoint small down>

	<TodoSectionsd>
        <Formsd>
			<b>Erzeugung der Signatur (r,s) und PubKey H</b>
			<fieldset className="is-horizontal">
		<button type='button' onClick={valuesReset}>
			Clear
		</button>				
        
		<label htmlFor='privkey'>
              <b>PrivKey d:</b>
              <input
                onChange={set("privkey")}
                value={values.privkey}
				name='privkey'
				min="1"
				max="6"
				maxLength = {1}
				type="text" inputmode="numeric"
				>
                </input>
            </label>
			
            <label htmlFor='zuf'>
			<b>ZufallsZahl k:</b>
              <input
			  className="fett"
                onChange={set("zuf")}
                value={values.zuf}
                name='zuf'
                maxLength = {1}
				type="text" inputmode="numeric"
				>
			 </input>
            </label>
			

       <label htmlFor='zufpx'>
          <b>{values.zuf}*G=(x,y):</b>
          <input style={{"width":"3em",}}
			value={"("+fzupx()+","+fzupy()+")"}
            name='zufpx'
			disabled="true"
            maxLength = {1}>
		  </input>
			
        </label>
        
			
        <label htmlFor='mess'>
             <b>msg</b>
              <input style={{"width":"75px",}}
                onChange={set("mess")}
                value={values.mess}
                name='mess'
				maxLength = {6}
              ></input>
        </label>
        
		<label htmlFor='zhash'>
              <b>Hash</b>
              <input 
                value={fzhash()}
                name='zhash'
				disabled="true"
                >
			  </input>
            </label>
		
		</fieldset>

		<fieldset className="is-horizontal">
		<label htmlFor='pubdx'>
          <b>H=(x,y):</b>
          <input style={{"width":"3em",}}
            value={"("+fpubdx()+","+fpubdy()+")"}
            name='pubdx'
			disabled="true"
			>
		  </input>
        </label>
		
        
		<label htmlFor='sigr'>
              <b>Signatur=(r,s):</b>
            <input                style={ fsigs()===0 || fsigr() === 0
				? {backgroundColor: "#f0f000","width":"3.5rem"} : 
				{backgroundColor: "#FFFFFF","width":"3.5rem"}}
               
			   value={"("+fsigr()+","+fsigs()+")"}
				
                name='sigr'
				disabled="true"				
               >
			 </input>
            </label>
            
            
			<label htmlFor='zfinv'>
            <b>k<sup>-1</sup><small><sub>|mod7</sub></small>:</b>
              <input
                value={fzfinv()}
                name='zfinv'
				disabled="true"
                ></input>
            </label>
<div />
          </fieldset>		  
<div />
       
			<br/><b>Prüfen der Signatur:</b><i> berechne <br/>
			u1=s<sup>-1</sup>*Hash<small><sub>|mod7</sub></small>&nbsp;<br/>
			u2=s<sup>-1</sup>*r<small><sub>|mod7</sub></small><br/> P=u1*G+u2*H</i>
			<fieldset>
            <label htmlFor='zhashcl'>
              <b>Client-Hash:</b>
              <input 
				onChange={set("zhashcl")}
				value={values.zhashcl}
                name='zhashcl'
				type="text" inputmode="numeric"
				maxLength = "2">
                </input>
            </label>
			
            <label htmlFor='u1'>
              <b>u1:</b>
              <input
				value={ 
				 fsinv()* parseInt(values.zhashcl+"")%7			  
				}
				disabled="true"         
                name='u1'
				>
               </input>
            </label>
            
			<label htmlFor='u2'>
              <b>u2:</b>
              <input
				value={
				  ( fsinv()* fsigr())%7				
				}
				disabled="true"         
                name='u2'
                >
				</input>
            </label>

            <label htmlFor='sinv'>
              <b>s<sup>-1</sup>|mod7</b>
              <input 
               
				disabled="true"
				value={fsinv()}  
                name='sinv'
				>
                </input>
            </label>			
            
			<label htmlFor='u1x'>
				<b>{fsinv()* parseInt(values.zhashcl+"")%7}*(1,1)=(x,y):</b>
              <input  style={{"width":"3em",}}
              
                value={"("+multkeyx(fsinv()* parseInt(values.zhashcl+"")%7,pointArray)+","+
				multkeyy( fsinv()* parseInt(values.zhashcl+"")%7,pointArray)+")"}
				disabled="true"
                name='u1x'
				>
			  </input>
            </label>
           
			<label htmlFor='u2x'>            
              <b>{fsinv()* fsigr()%7}*H=(x,y):</b>
               <input  style={{"width":"3em",}}
				 value={"("+multkeyx(fsinv()* fsigr()*values.privkey,pointArray)+","+
					multkeyy(fsinv()* fsigr()*values.privkey,pointArray)+")"}
                 name='u2x'

				 >
			  </input>
            </label>

         
			<b>Signatur({fsigr()},{fsigs()})
			</b>
			
          </fieldset>
	 
  		<fieldset>

			<b> P=(x<sub>P</sub>,y<sub>P</sub>)=u1*G+u2*H=
			(	{
					multkeyx((fsinv()* values.zhashcl + fsinv()* fsigr()* values.privkey)%7,pointArray)
				},
				{
					multkeyy((fsinv()* values.zhashcl + fsinv()* fsigr()* values.privkey)%7,pointArray) 
				} ) </b>
           
          </fieldset>

 		 <u>Prüfung</u>  gilt:<br/>
		 <b> {multkeyx((fsinv()* values.zhashcl + fsinv()* fsigr()* values.privkey)%7,pointArray)}
		 = x<sub>P</sub>
		 </b>
		 {(multkeyx((fsinv()* values.zhashcl + fsinv()* fsigr()* values.privkey)%7,pointArray)===fsigr())?
		 <span style={{color: "green"}}>  = r <small><sub>|mod7</sub></small> </span>: 
		 <span style={{color: "red"}}> ungleich r<small><sub>|mod7</sub></small></span>}
		 
		 ={fsigr()}
		<ol>
		<i><u>
		Bemerkung:</u><br/><b> xp kann für einzelne Kombinationen von d,z,Hash und Client-Hash 
		auch bei einem anderen zur Prüfung eingegebenen Client-Hash stimmen, was aber der kleinen Primzahl P=7 geschuldet ist.<br/>
		r und xp sind funktionale Ergebnisse der Eingabewerte d,k,Hash und Client-Hash, alles
		Zahlen aus einem Bereich, der sehr viel größer ist als die Anzahl Sandkörner auf der Erde.
		Dass ein anderer Wert von x<sub>P</sub> (z.B. anderer Client-Hash) mit r zufällig übereinstimmt ist 
		damit äußerst unwahrscheinlich.
		</b><br/>
		</i>
		</ol> 
        </Formsd>
      </TodoSectionsd>
</Breakpoint>

<Breakpoint medium up>	  

	<TodoSection>
		
        <Form>
			<b>Erzeugung der Signatur (r,s) und PubKey H</b>
			<fieldset className="is-horizontal">
		<button type='button' onClick={valuesReset}>
			Clear
		</button>				
        
		<label htmlFor='privkey'>
              <b>PrivKey d:</b>
              <input
				className="fett"
                onChange={set("privkey")}
                value={values.privkey}
				name='privkey'
                maxLength = {1}
				type="text" inputmode="numeric"
				>
                </input>
            </label>
		<label htmlFor='pubdx'>
          <b>PubKey H={values.privkey%7}*G:</b>
          <input style={{"width":"2rem",}}
			value={"("+fpubdx()+","+fpubdy()+")"}
            name='pubdx'
			disabled="true"
			>
		  </input>
        </label>
			
            <label htmlFor='zuf'>
			<b>ZufallsZahl k:</b>
              <input
			  className="fett"
                onChange={set("zuf")}
                value={values.zuf}
                name='zuf'
                maxLength = {1}
				type="text" inputmode="numeric"
				>
			 </input>
            </label>
			

       <label htmlFor='zufpx'>
          <b> {values.zuf%7}*G:</b>
          <input  style={{"width":"2rem",}}
			value={"("+fzupx()+","+fzupy()+")"}
            name='zufpx'
			disabled="true"
        >
		  </input>
			
        </label>
            
			<label htmlFor='zfinv' >
            <b>k<sup>-1</sup>:</b>
              <input
                value={fzfinv()}
                name='zfinv'
				disabled="true"
				style={{"width":"1rem",}}
                ></input>
            </label>

 		</fieldset>

		<fieldset className="is-horizontal">

       <label htmlFor='mess'>
             <b>msg</b>
              <input style={{"width":"3rem",}}
                onChange={set("mess")}
                value={values.mess}
                name='mess'
				maxLength = {6}
              ></input>
        </label>
        
		<label htmlFor='zhash'>
              <b>Hash</b>
              <input 
                value={fzhash()}
                name='zhash'
				disabled="true"
                >
			  </input>
            </label>

		
            
		<label htmlFor='sigr'>
              <b>Signatur(r,s):
            <input 
               style={ fsigs()===0 || fsigr() === 0
				? {backgroundColor: "#f0f000","width":"2rem"} : 
				{backgroundColor: "#FFFFFF","width":"2rem"}}
			   value={"("+fsigr()+","+fsigs()+")"}

                name='sigr'
				disabled="true"				
               >
			 </input></b>
            </label>
            

            <label htmlFor='sinv'>
              <b>s<sup>-1</sup>|mod7</b>
              <input 
               
				disabled="true"
				value={fsinv()}  
                name='sinv'
				>
                </input>
            </label>			


<div />
        </fieldset>		  
<div />
       
			<br/><b>Prüfen der Signatur:</b><i> berechne <br/>
			u1=s<sup>-1</sup>*Hash<small><sub>|mod7</sub></small>&nbsp; &nbsp;&nbsp;&nbsp;
			u2=s<sup>-1</sup>*r<small><sub>|mod7</sub></small> P=u1*G+u2*H</i><br/><br/>
		<fieldset>

            <label htmlFor='zhashcl'>
              <b>Client-Hash:</b>
              <input 
				onChange={set("zhashcl")}
				value={values.zhashcl}
                name='zhashcl'
				type="text" inputmode="numeric"
				maxLength = "2">
                </input>
            </label>
			
            <label htmlFor='u1'>
              <b>u1:</b>
              <input
				value={ 
				 fsinv()* parseInt(values.zhashcl+"")%7			  
				}
				disabled="true"         
                name='u1'
				>
               </input>
            </label>
            
			<label htmlFor='u2'>
              <b>u2:</b>
              <input
				value={
				  ( fsinv()* fsigr())%7				
				}
				disabled="true"         
                name='u2'
                >
				</input>
            </label>
		</fieldset>
		<fieldset>
         
			<label htmlFor='u1x'>
              <b>{"u1*G="+fsinv()* parseInt(values.zhashcl+"")%7}*G=</b>
              <input style={{"width":"2rem",}}
			    value={"("+
				  multkeyx(fsinv()* parseInt(values.zhashcl+"")%7,pointArray)+
					"," +
				  multkeyy( fsinv()* parseInt(values.zhashcl+"")%7,pointArray)+
				  ")"}
				disabled="true"
                name='u1x'
				>
			  </input>
            </label>
            
			<label htmlFor='u2x'>            
				<b>{"u2*H="+fsinv()* fsigr()%7}*H=</b>
               <input style={{"width":"2rem",}}
			   
                  value={"("+
					 multkeyx(fsinv()* fsigr()*values.privkey,pointArray)+
					 ","+
					 multkeyy(fsinv()* fsigr()*values.privkey,pointArray)+
				   ")"}
                 name='u2x'

				 >
			  </input>
            </label>
           
			<b>Signatur({fsigr()},{fsigs()})
			</b>

		</fieldset>
		<fieldset>

			<b> P=(x<sub>P</sub>,y<sub>P</sub>)=u1*G+u2*H=
			(	{
					multkeyx((fsinv()* values.zhashcl + fsinv()* fsigr()* values.privkey)%7,pointArray)
				},
				{
					multkeyy((fsinv()* values.zhashcl + fsinv()* fsigr()* values.privkey)%7,pointArray) 
				} ) </b>
           
          </fieldset>

 		 <u>Prüfung</u>  gilt:<br/>
		 <b> {multkeyx((fsinv()* values.zhashcl + fsinv()* fsigr()* values.privkey)%7,pointArray)}
		 = x<sub>P</sub>
		 </b>
		 {(multkeyx((fsinv()* values.zhashcl + fsinv()* fsigr()* values.privkey)%7,pointArray)===fsigr())?
		 <span style={{color: "green"}}>  = r <small><sub>|mod7</sub></small> </span>: 
		 <span style={{color: "red"}}> ungleich r<small><sub>|mod7</sub></small></span>}
		 
		 ={fsigr()}

		<ol>
		<i><u>
		Bemerkung:</u><br/><b> xp kann für einzelne Kombinationen von d,z,Hash und Client-Hash 
		auch bei einem anderen zur Prüfung eingegebenen Client-Hash stimmen, was aber der kleinen Primzahl P=7 geschuldet ist.<br/>
		r und xp sind funktionale Ergebnisse der Eingabewerte d,k,Hash und Client-Hash, alles
		Zahlen aus einem Bereich, der sehr viel größer ist als die Anzahl Sandkörner auf der Erde.
		Dass ein anderer Wert von x<sub>P</sub> (z.B. anderer Client-Hash) mit r zufällig übereinstimmt ist 
		damit äußerst unwahrscheinlich.
		</b><br/>
		</i>
		</ol> 

        </Form>

      </TodoSection>
</Breakpoint>
 </>
  );	  
}


const Formsd = styled.form`
  padding: 1rem;
  border-radius: 10px;
  border: 1px solid #bbb;
  margin: 0;
  fieldset {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin: 0;
  }
 .fett {
	font-weight: 600;
 }
 
  label {
    display: flex;
    justify-content: space-between;
	margin-left: 0px;
	font-size: 1.2em;	
  }
  
input:disabled {
    height: 2rem;
    width: 2rem;
    border: 1px solid #000;
    margin-top: 0px;
	margin-left: 15px;
  font-size: 1.2rem;	
   font-weight: 600;	
}  
  
input {
    height: 2rem;
    width: 2rem;
    border: 1px solid #000;
    margin-top: 0px;
	margin-left: 15px;
	font-size: 1.2rem;	
	font-weight: 600;	
}  

  button {
    width: 100%;
    align-self: flex-start;
  }
`;

const Form = styled.form`
	width: 70vw;
  padding: 20px;
  border-radius: 10px;
  border: 1px solid #bbb;
  fieldset {
    display: flex;
	justify-content: space-between;
    flex-direction: row;
    gap: 0.25rem;
    margin: auto;
  }

  label {
//    height: 1rem;
//    width: 1rem;	  
    display: flex;
    justify-content: space-between;
	margin-left: 0px;
  font-size: 0.8rem;	
   font-weight: 600;	
  }

input:disabled {
	background-color: "#00ffff";
//    height: 1rem;
//    width: 1rem;
    border: 1px solid #000;
    margin-top: 0px;
	margin-left: 5px;
   font-size: 0.8rem;	
   font-weight: 600;	
}  
  
input {
//    
	background-color: "#ffff00";
	height: 1rem;
    width: 1rem;
    border: 1px solid #000;
    margin-top: 0px;
	margin-left: 5px;
  font-size: 0.8rem;	
   font-weight: 600;	
}  

  button {
    width: 45px;
    align-self: flex-end;
  }
`;

const TodoSectionsd = styled.section`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 10px;
  max-width: 1000px;
  margin: auto;
  margin-left: 10px;


  p {
	margin: 0;
  }

  input {
	color: #010101;
   font-size: 1.2rem;	
   font-weight: 600;	
  } 
  .heading {

    font-size: 1.25rem;
    font-weight: 600;
    color: #555;
    text-decoration: underline;
	margin-bottom: 2;
  } 
`;

const TodoSection = styled.section`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 10px;
  max-width: 1000px;
  margin: auto;
  margin-left: 10px;

  p {
    margin: 0;
  }

  .heading {
    font-size: 1.25rem;
    font-weight: 600;
    color: #555;
    text-decoration: underline;
    margin-bottom: 0.25rem;
  }
`;

export const AddNewButton = styled.button`
  margin: auto 20px;
  height: 100px;
  width: 70px;
  border: none;
  border-radius: 10px;
  background-color: #ccccff;
  font-size: 50px;
  cursor: pointer;
  box-shadow: 0 0 5px #ddd;
  transition: 0.2s;
  :hover {
    box-shadow: 5px 5px 20px #ddd;
    transform: scale(1.05);
  }
`;
